// third-party
import { createSlice } from "@reduxjs/toolkit";

// project imports
import axios from "utils/axios";
import { dispatch } from "../index";

// initial state
interface buildingState {
  error: Error | null;
  list: Equip[];
  replace: Equip[];
  current: number;
  calculate: boolean;
  expend: Expend | null;
}

const initialState: buildingState = {
  error: null,
  list: [],
  replace: [],
  current: 0,
  calculate: false,
  expend: null
};

const EQUIP_TYPE_ARRAY = [1, 2, 3, 4, 5, 6];

// ==============================|| SLICE - MENU ||============================== //

const equip = createSlice({
  name: "equip",
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = action.payload;
    },

    getListSuccess(state, action) {
      const _list = action.payload;
      const list = EQUIP_TYPE_ARRAY.map((equipType) => {
        const equip = _list.find((item: Equip) => item.equip_type === equipType);

        return (
          equip || {
            equip_id: "",
            equip_name: "",
            equip_type: equipType,
            icon: "",
            background: "",
            quality: "",
            relpace_equip: {
              equip_id: "",
              equip_name: "",
              equip_type: equipType,
              icon: "",
              background: "",
              quality: ""
            }
          }
        );
      });

      state.list = list;
    },

    setNewEquip(state, action) {
      const { relpaceEquip } = action.payload;
      const _list: Equip[] = JSON.parse(JSON.stringify(state.list));

      _list.forEach((equip, buildingIndex) => {
        if (equip.equip_type === relpaceEquip.equip_type) {
          _list[buildingIndex].relpace_equip = relpaceEquip;
        }
      });

      state.list = _list;
    },

    getCurrentSuccess(state, action) {
      state.current = action.payload;
    },

    getReplaceSuccess(state, action) {
      state.replace = action.payload;
    },

    setCalculateModal(state, action) {
      state.calculate = action.payload;
    },

    getEquipExpendSuccess(state, action) {
      state.expend = action.payload;
    }
  }
});

export default equip.reducer;

// Actions
export const { getListSuccess, setNewEquip, setCalculateModal } = equip.actions;

export function getList() {
  return async () => {
    try {
      const getMyPromise = axios.post(`equip/get_my`);

      Promise.all([getMyPromise]).then((values) => {
        const getMyResponse = values[0];
        if (getMyResponse.data.code === 0) {
          const myEquipList = getMyResponse.data.data.my_equip_list || [];
          const totalScore = getMyResponse.data.data.total_power;

          // 将宝石类型列表和宝石列表合并
          const myEquipListWithEquipType = myEquipList.map((myEquip: Equip) => {
            return {
              ...myEquip,
              relpace_equip: myEquip
            };
          });

          dispatch(equip.actions.getListSuccess(myEquipListWithEquipType));
          dispatch(equip.actions.getCurrentSuccess(totalScore));
        } else {
          dispatch(equip.actions.getListSuccess([]));
        }
      });
    } catch (error) {
      dispatch(equip.actions.getListSuccess([]));
      dispatch(equip.actions.hasError(error));
    }
  };
}

export function getEquipReplace(equipType: number, equipId: string, quality: number) {
  return async () => {
    try {
      const response = await axios.post(`equip/get`, { equip_type: equipType, equip_id: equipId, quality: quality });

      if (response.data.code === 0) {
        dispatch(equip.actions.getReplaceSuccess(response.data.data.equip_list));
      } else {
        dispatch(equip.actions.getReplaceSuccess([]));
      }
    } catch (error) {
      dispatch(equip.actions.getReplaceSuccess([]));
      dispatch(equip.actions.hasError(error));
    }
  };
}

interface EquipIdPair {
  current_equip_id: string;
  expect_equip_id: string;
}

export function getEquipExpend(equipIdPairs: EquipIdPair[]) {
  return async () => {
    try {
      const response = await axios.post(`equip/calculate`, { equip_list: equipIdPairs });

      if (response.data.code === 0) {
        dispatch(equip.actions.getEquipExpendSuccess(response.data.data));
      } else {
        dispatch(equip.actions.getEquipExpendSuccess(null));
      }
    } catch (error) {
      dispatch(equip.actions.getEquipExpendSuccess(null));
      dispatch(equip.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export interface Equip {
  equip_id: string;
  equip_name: string;
  equip_type: number;
  icon: string;
  background: string;
  quality: string;
  relpace_equip: Equip;
}

export interface RequestItem {
  item_name: string;
  value: number;
  icon: string;
}

export interface BenefitItem {
  base_val: number;
  benefit_type: string;
  value: number;
}

export interface SuitBenefit {
  count: number;
  suit_name: string;
  benefit: BenefitItem[];
}

export interface Expend {
  expect_power: number;
  request_list: RequestItem[];
  benefit: BenefitItem[];
  suit_benefit: SuitBenefit[];
}
